// extracted by mini-css-extract-plugin
export default {"text":"CreateDocumentByLinkDialog__text--1QH5t"};